import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Mission } from '@shared/entities/mission';
import { ApiService } from '@shared/services';
import { Observable } from 'rxjs';

export interface MissionFilter {
  serialNumber?: string;
  startDate?: string;
  endDate?: string;
  aggregation?: 'DAY' | 'MONTH';
}

@Injectable({
  providedIn: 'root'
})
export class MissionService extends ApiService<Mission> {
  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/missions';
    const detailUrl = '/missions';

    super(Mission, masterUrl, detailUrl, 'missions');
  }

  getByFilters(filters: MissionFilter): Observable<Mission[]> {
    const { locationId } = this.activatedRoute.snapshot.queryParams;
    if (locationId) {
      this.setUrlParameter('locationId', locationId);
    }
    if (filters.serialNumber) {
      this.setUrlParameter('serialNumber', filters.serialNumber);
    }

    if (filters.startDate) {
      this.setUrlParameter('startDate', filters.startDate);
    }

    if (filters.endDate) {
      this.setUrlParameter('endDate', filters.endDate);
    }

    this.setUrlParameter('aggregation', filters.aggregation || 'DAY');

    return this.findAll().pipe();
  }
}
